import {Label} from "reactstrap";
import AsteriskIcon from "../../asteriskIcon";

const AlertFormLabel = ({label, required = true}) => {
  return (
    <div className="d-flex">
      <Label className="form-control-label alert-label roboto-normal">{label}</Label>
      {required && <AsteriskIcon />}
    </div>
  );
};

export default AlertFormLabel;
